import { InstagramUser } from '@/types/assets'
import Axios from 'axios'

class InstagramManager {
  static async getUser (instagramUrl: string|undefined): Promise<InstagramUser|null> {
    if (instagramUrl === undefined) {
      return null
    }
    try {
      const response = await Axios.get(instagramUrl)
      if (response.status !== 200) {
        return null
      }
      const username = response.data.split(' (@')[1].split(') ')[0]
      const id = response.data.split('owner_user_id" content="')[1].split('"')[0]
      const user: InstagramUser = {
        id,
        name: username
      }
      return user
    } catch(e) {
      console.log('Could not grab username for instagram post')
      return {
        id: '0',
        name: ''
      }
    }
  }
}

export default InstagramManager
